import { createPostEndpoint } from '@sonar-software/sonar-http';
import { SonarObjectTypeId } from '@sonar-software/sonar-ts-types';

export type PostDataDictionaryViewRequest = {
	applicationId: number | undefined;
	columns: string;
	complianceCategory: number | undefined;
	filter: string;
	ordering: string;
	sonarObjectId: number | undefined;
	sonarObjectTypeId: SonarObjectTypeId | undefined;
	tagId: number | undefined;
	viewName: string;
};

export type PostDataDictionaryViewResponse = {
	viewId: number;
};

export const postDataDictionaryView = createPostEndpoint<PostDataDictionaryViewRequest, PostDataDictionaryViewResponse>(
	'/api/v3/data-dictionary/views'
);
